import GroupProductContributions from './GroupProductContributions'

export default GroupProductContributions
